module.exports = __webpack_public_path__ + "static/media/SOLAR_ONE.4eacda5e.png";